import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment as ENV } from '../../environments/environment';
import { IUserInfo } from '../models/Auth';
import { ImpersonationFoundStudent } from '../models/Impersonation';
import { User } from '../models/Auth';
import { AuthService } from './auth.service';

@Injectable({ providedIn: "root" })
export class ImpersonationService {
    constructor(private http: HttpClient, private auth: AuthService) { }

    public get apiUrl(): string { return `${ENV.apiUrl}/impersonation` }

    start(user: ImpersonationFoundStudent): Observable<User> {
        return this.http.post(this.apiUrl, {
            UserId: user.Email,
            FirstName: user.FirstName,
            LastName: user.LastName
        }).pipe(tap((data: IUserInfo) => {
            this.auth.setUser(data);
        }), map(t => {
            return this.auth.currentUser;
        }));
    }

    end(): Observable<User> {
        return this.http.delete(this.apiUrl).pipe(tap((data: IUserInfo) => {
            this.auth.setUser(data);
        }), map(t => {
            return this.auth.currentUser;
        }));
    }
}
